import { render, staticRenderFns } from "./resb.vue?vue&type=template&id=5b922470&"
import script from "./resb.vue?vue&type=script&lang=js&"
export * from "./resb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports